module.exports = __webpack_public_path__ + "static/media/mountsinai.72b69161.png";